export enum MODAL_TYPES {
  CONFIRM = "CONFIRM",
  RENAME_CHAT = "RENAME_CHAT",
  RUN_EVAL = "RUN_EVAL",
}

export enum OVERLAY_TYPES {
  CREATE_EDIT_PROJECT = "CREATE_EDIT_PROJECT",
  CREATE_EDIT_PROCEDURE = "CREATE_EDIT_PROCEDURE",
  EDIT_USER = "EDIT_USER",
  ASSIGN_ONBOARDING = "ASSIGN_ONBOARDING",
  ASSIGN_PROCEDURE = "ASSIGN_PROCEDURE",
  ASSIGN_SURVEY = "ASSIGN_SURVEY",
  CREATE_EDIT_USER_MEETING = "CREATE_EDIT_USER_MEETING",
  CREATE_EDIT_GOAL = "CREATE_EDIT_GOAL",
  SHOW_GOAL_COMMENTS = "SHOW_GOAL_COMMENTS",
  CLOSE_GOAL = "CLOSE_GOAL",
  SHOW_RECOGNITION_DETAILS = "SHOW_RECOGNITION_DETAILS",
  SHOW_RECOGNITION_CREATION_NOTE = "SHOW_RECOGNITION_CREATION_NOTE",
  CREATE_RECOGNITION = "CREATE_RECOGNITION",
  FINISH_ONBOARDING_POPUP = "FINISH_ONBOARDING_POPUP",
  SHOW_BADGE_DETAILS = "SHOW_BADGE_DETAILS",
  // 923-core-context context/engineering/spark-rewards/phase-49-w4-approve-deny.md: the required deny-reason overlay. W5 removed the MARK_CONSUMED member
  // that used to sit directly above this one, and its whole containers/components trees (architecture
  // §6.1) -- this member and its OverlayWrapper case were deliberately placed together so a
  // folder-proximity cleanup pass would not take this one out too.
  DENY_REDEMPTION_REQUEST = "DENY_REDEMPTION_REQUEST",
  // 923-core-context context/engineering/spark-rewards/phase-53-decline-reason-and-decision-buttons.md PR3: the Review table's own required decline-reason
  // overlay, mirroring DENY_REDEMPTION_REQUEST's own shape above -- placed directly adjacent to it for
  // the same folder-proximity-cleanup reason that member's own comment records.
  DECLINE_RECOGNITION = "DECLINE_RECOGNITION",
  // 923-core-context context/engineering/spark-rewards/phase-55-person-sparks-drawer.md PR2: the read-only "a person's Sparks" drawer, opened from the
  // Redemptions tab's ledger rows and Pending requests' "Who" name -- placed directly adjacent to its
  // two siblings above for the same folder-proximity-cleanup reason their own comments record.
  PERSON_SPARKS = "PERSON_SPARKS",
}

export enum ROLE {
  SUPER_ADMIN = "Super Admin",
  HR = "HR",
  CONTRACTOR = "Contractor",
  TEAM_LEADER = "Team Lead",
  PROCEDURE_MANAGER = "Procedure Manager",
}

export enum INPUT_TYPES {
  PASSWORD = "password",
  TEXT = "text",
}

export enum ORDER_TYPE {
  DESC = "desc",
  ASC = "asc",
  NONE = "",
}

export enum GOOGLE_DOC_VIEW_TYPE {
  PREVIEW = "preview",
}

export enum CONTRACTOR_FILTER_DROPDOWN_OPTIONS {
  ASSIGNED_TO_ME = "Assigned to me",
  ALL = "All",
}

export const PROCESS_INTERRACTIVE_SCHEMA_URL = "https://credentials923.webflow.io/credentials/process-interactive";
// bug 04: the external Webflow schema page is broken; flip to true to bring both links back.
export const IS_PROCESS_SCHEMA_ENABLED = false;
export const GOOGLE_DOC_URN = "docs.google.com";
